import { Record } from "immutable";

const RankingRecord = Record({
  measureSize: {
    data: [],
    xCategories: []
  },
  strengthOfESAndRelationship: {
    data: [],
    xCategories: []
  },
  commentId: null,
  comment: "",
  initComment: ""
});

class Ranking extends RankingRecord {}

export default Ranking;



// WEBPACK FOOTER //
// ./src/models/Ranking.js